// 編集画面の設定サイドバー

import React from 'react';

import { useEditorSidebar } from '../../../context/EditorSidebarContext';

type Props = {
  children: React.ReactNode;
};

const EditorSidebar = ({ children }: Props) => {
  const { isOpen, toggleSidebar } = useEditorSidebar();
  return (
    <>
      <div className={`h-full border-r border-solid ${isOpen ? 'w-72' : 'w-[68px]'}`}>
        <button
          type='button'
          className='flex h-[60px] w-full items-center justify-between gap-1 border-b border-solid border-b-gray-200 bg-gray-150 px-[12px] transition-opacity hover:opacity-60'
          onClick={toggleSidebar}
        >
          <span className='text-xs'>設定</span>
          <svg
            width='12'
            height='12'
            viewBox='0 0 12 12'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            className={`${isOpen ? 'rotate-180' : ''}`}
          >
            <path
              d='M6.83333 6L3 2.16667L4.16667 1L9.16667 6L4.16667 11L3 9.83333L6.83333 6Z'
              fill='#292929'
            />
          </svg>
        </button>
        {isOpen && (
          <div className='sticky top-0 flex max-h-screen flex-col gap-5 p-4 '>{children}</div>
        )}
      </div>
    </>
  );
};

export default EditorSidebar;
